import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: 10,
    position: 'relative',
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    borderTopLeftRadius: (useStylesParams) =>
      useStylesParams.size === 'small' ? 0 : theme.shape.borderRadius,
    borderBottomLeftRadius: (useStylesParams) =>
      useStylesParams.size === 'small' ? 0 : theme.shape.borderRadius,
    boxShadow: theme.shadows[6],
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  container: {
    width: '100%',
    height: '100%',
  },
  header: {
    padding: 15,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    boxShadow: theme.shadows[3],
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    zIndex: 10,
  },
  footer: {
    padding: 15,
    paddingTop: 20,
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
  },
  recording: {
    minWidth: 15,
    height: 15,
    borderRadius: '50%',
    backgroundColor: theme.palette.error.main,
    animation: '$pulse 500ms infinite ease-in-out',
  },
  '@keyframes pulse': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.25 },
    '100%': { opacity: 1 },
  },
  knowledge: {
    zIndex: 11,
    background: '#fff',
    width: '100%',
    position: 'absolute',
    left: 0,
    padding: 15,
    borderTopLeftRadius: theme.shape.borderRadius * 2,
    borderTopRightRadius: theme.shape.borderRadius * 2,
  },
  knowledgeSuggestions: {
    display: 'flex',
    flexDirection: 'row',
  },
  actionButton: {
    padding: 10,
    marginRight: 10,
    minWidth: 300,
    cursor: 'pointer',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    fontSize: theme.typography.fontSize,
    borderRadius: theme.shape.borderRadius,
    transition: 'all 200ms ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.hover2,
    },
  },
  stage2: {
    width: '100%',
    padding: 15,
    paddingLeft: 15,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    overflowX: 'auto',
    overflowY: 'hidden',
    cursor: 'grab',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  footerTab: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-between',
    alignItems: 'center',
    padding: '23px 26px',
    gap: '15px',
    borderTop: `1px solid ${theme.palette.border}`,
    borderRadius: theme.shape.borderRadius,
    background: ` ${theme.palette.primary.tertiary}`,
  },
}))

export default useStyles
